module.exports = __webpack_public_path__ + "static/img/p9.d0e9809.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/projects/p9.jpg
// module id = 70
// module chunks = 1